import React from "react";
import { Route, Routes } from "react-router-dom";
import DeliveryAreaSearch from "./areaSearch";
import DeliveryManagement from "./deliveryManagement";

const DeliveryManagementRoutes = () => {
    return (
        <Routes>
            <Route path="area-search" element={<DeliveryAreaSearch />} />
            <Route path="/" element={<DeliveryManagement />} />
        </Routes>
    );
};

export default DeliveryManagementRoutes;
